import { getUserInfo, requestLogin, requestLogout } from '@/api/user';
import router from '@/router';
import store from '..';
import { getToday, getLastDay } from '@/utils/dateCalculation';
import { getPushToken } from '@/utils/nativeRequestFunctions';

export default {
	namespaced: true,
	state: {
		userInfo: {
			user: {
				beSavedId: '',
				enrollment_date: '',
				employee_number: '',
				state: '',
				name: '',
				tel: '',
				email: '',
				id: 0,
				belong_pk: 0,
				customer_care: '',
				showCheckPopupYn: 'N',
			},
			receipt_division: [],
			center: [],
		},
		isLogin: false,
	},
	mutations: {
		setLogout(state) {
			state.isLogin = false;
		},
		setLogin(state) {
			state.isLogin = true;
		},
		setSavedId(state, payload) {
			state.beSavedId = payload;
		},
		setUserInfo(state, payload) {
			const userPayload = payload?.user?.user ? payload.user : payload;
			// 제외할 키 목록
			const excludeKeys = [
				'access_token',
				'access_token_end_date',
				'refresh_token',
				'refresh_token_end_date',
				'remember_token',
			];

			const filteredUser = Object.fromEntries(
				Object.entries(userPayload.user).filter(([key]) => !excludeKeys.includes(key)),
			);
			filteredUser.showCheckPopupYn =
				payload.showCheckPopupYn || userPayload.showCheckPopupYn || filteredUser.showCheckPopupYn || 'N';

			if (!state.userInfo || typeof state.userInfo !== 'object' || !('user' in state.userInfo)) {
				console.warn('[WARN] state.userInfo 구조 이상. 초기화 강제 수행.');
				state.userInfo = {
					user: {},
					receipt_division: [],
					center: [],
				};
			}

			state.userInfo.user = filteredUser;
			state.userInfo.receipt_division = userPayload.receipt_division;
			state.userInfo.center = userPayload.center;
		},
		resetData(state) {
			// beSavedId는 유지, 나머지 값만 명시적으로 초기화
			const beSavedId = state.beSavedId;
			state.userInfo = {
				user: {
					beSavedId: '',
					// TODO : 아이디 저장 기능 추가 요청 시 사용 예정
					// beSavedId: beSavedId,
					enrollment_date: '',
					employee_number: '',
					state: '',
					name: '',
					tel: '',
					email: '',
					id: 0,
					belong_pk: 0,
					customer_care: '',
					showCheckPopupYn: 'N',
				},
				receipt_division: [],
				center: [],
			};
			state.isLogin = false;
		},
	},
	actions: {
		SET_USER_INFO({ commit }) {
			return new Promise((resolve, reject) => {
				getUserInfo()
					.then((data) => {
						commit('setUserInfo', data);
						resolve();
					})
					.catch((fail) => {
						router.push({ name: 'Signin' });
						reject();
					});
			});
		},
		LOGIN({ commit, dispatch }, { employee_number, password }) {
			return new Promise((resolve, reject) => {
				requestLogin({ employee_number, password })
					.then(async ({ user }) => {
						const { access_token, refresh_token } = user;
						store.commit('token/setToken', { access_token, refresh_token });
						commit('setLogin');
						commit('setSavedId', employee_number);
						await dispatch('SET_USER_INFO');
						await getPushToken(); // push token(fcm 토큰) 요청

						router.push({
							name: 'Home',
							query: {
								page: 1,
								filter_start_date: getToday(),
								filter_end_date: getLastDay(),
								state_type: '전체',
							},
						});
						resolve();
					})
					.catch((error) => {
						const message = error?.message || '오류가 발생했습니다. 관리자에게 문의하세요.';
						reject();
						// 로그인 실패 시 메시지 출력
						alert(message);
						// store.commit('toast/alert', message);
					});
			});
		},
		async LOGOUT({ commit }) {
			// 결과에 상관없이 무조건 로그아웃 시킴
			const res = await requestLogout();
			commit('setLogout');
			commit('resetData');
			store.commit('token/clearToken');
			router.push({ name: 'Signin' });
		},
	},
};
